import * as React from 'react';
import Moment from 'moment';
import { ExcelExport, ExcelExportColumn, ExcelExportColumnGroup } from '@progress/kendo-react-excel-export';
import { Transaction } from './TransactionsList';

interface ExportCSVState {
    csvData: Array<any>;
}

class ExportCSV extends React.Component<{}, ExportCSVState> {

    constructor(props) {
        super(props);
        this.state = {
          csvData: []
        }
    }

    _exporter;
    export = () => {
        this._exporter.save();
    }

    setData = (csvData) => {
        this.setState({ csvData: csvData });
    }

    render() {
        let returnVal = [];
        for (let index = 0; index < this.state.csvData.length; index++) {

            const DateProcessedRaw = this.state.csvData[index].transactionList.requestCreated;
            const formattedDate = Moment(DateProcessedRaw).format("LL");

            returnVal.push(
                {
                    DateProcessed: formattedDate,
                    PaymentDescription: this.state.csvData[index].transactionList.paymentPurpose,
                    PaymentReference: this.state.csvData[index].transactionList.paymentReference,
                    PaymentType: this.state.csvData[index].transactionList.paymentStatus,
                    PaymentAmount: this.state.csvData[index].transactionList.paymentAmount
                },
            );

            for (let j = 0; j < this.state.csvData[index].transactionsParts.length; j++) {

                const DateApplicationRaw = this.state.csvData[index].transactionsParts[j].dateApplied;
                const formattedApplicationDate = Moment(DateApplicationRaw).format("LL");

                returnVal.push(
                    {
                        DateOfApplication: formattedApplicationDate,
                        Reason: this.state.csvData[index].transactionsParts[j].transactionReason,
                        Relatesto: this.state.csvData[index].transactionsParts[j].paymentPlanName,
                        Payment: this.state.csvData[index].transactionsParts[j].paidAmount,
                        Payment1: this.state.csvData[index].transactionsParts[j].paidAmount

                    });

            }
            returnVal.push({ '': '' });
        }

        let now = Moment();
        const formattedFileName = 'payrighttransaction_' + now.format("YYYYMMDDHHmmss") + '.xlsx';

        return (
            <ExcelExport
                data={returnVal}
                fileName={formattedFileName}
                filterable={false}
                ref={(exporterRef) => { this._exporter = exporterRef; }}
            >
                <ExcelExportColumn field="DateProcessed" title="Date Processed" width={120} />
                <ExcelExportColumn field="PaymentDescription" title="Payment Description" width={150} />
                <ExcelExportColumn field="PaymentReference" title="Payment Reference" width={150} />
                <ExcelExportColumn field="PaymentType" title="Payment Type" width={120} />
                <ExcelExportColumn field="PaymentAmount" title="Payment Amount" width={120} />
                <ExcelExportColumnGroup
                    title="Transaction Details"
                    headerCellOptions={{ textAlign: 'center', background: '#531DFF' }}
                >
                    <ExcelExportColumn field="DateOfApplication" title="Date" width={120} cellOptions={{
                        color: '#531DFF',
                        textAlign: 'center'

                    }} headerCellOptions={{
                        background: '#531DFF',
                        textAlign: 'center'
                    }} />
                    <ExcelExportColumn field="Reason" title="Transaction Type" width={200} cellOptions={{
                        color: '#531DFF',
                        textAlign: 'center'
                    }} headerCellOptions={{
                        background: '#531DFF',
                        textAlign: 'center'
                    }} />
                    <ExcelExportColumn field="Relatesto" title="Relates To" width={120} cellOptions={{
                        color: '#531DFF',
                        textAlign: 'center'
                    }} headerCellOptions={{
                        background: '#531DFF',
                        textAlign: 'center'
                    }} />
                    <ExcelExportColumn field="Payment" title="Amount ($)" width={120} cellOptions={{
                        color: '#531DFF',
                        textAlign: 'center'

                    }} headerCellOptions={{
                        background: '#531DFF',
                        textAlign: 'center'
                    }} />
                </ExcelExportColumnGroup>
            </ExcelExport>
        )
    }
}

export default ExportCSV;
